import { FC, Fragment } from "react";
import HomeBannerOne from "./common/HomeBannerOne";
import HomeBannerTwo from "./common/HomeBannerTwo";
import HomeTaxonomy from "./common/HomeTaxonomy";
import { ILatestPostsGroup } from "models/latestPosts";
import { ISEOTrendingBlock } from "models/seoTrendingBlocks";
import dynamic from "next/dynamic";
import { useTheme } from "styled-components";
import { useSsoContext } from "contexts/authSSOContext";
import HomeWidgets from "./common/HomeWidgets";
import { IHome } from "../types/home";
import { useIsCustomizeAds } from "../../../../hooks/useIsCustomizeAds";
import { getCustomThemeValue, isShobiddak } from "helpers/osHelpers";
import { AddPostCont, AdsContainer, HomeAdsHeight } from "./home.styled";
import WidgetGetMoreListing from "../../../../componentReusable/EntryPoints/WidgetGetMoreListing";
import { classNames } from "helpers/themeHelpers";
import WidgetAddListing from "../../../../componentReusable/EntryPoints/WidgetAddListing";
import { AddPostProvider } from "../../../../componentReusable/Providers/AddPostProvider";
import { getIntegrationLink } from "helpers/links-builders/loggedInLinks";
import { EnumIntegrationEvent } from "../../../../enums/EnumIntegrationEvent";
import {EnumLoggingScreenNames, EnumWidgets} from "../../../../libs/logging/types/loggingTypes";
import IconAddPost from "assets/icons/IconAddPost";
import LazyLoadWindowScroll from "components/LazyLoadWindowScroll/LazyLoadWindowScroll";
import AdsBillBoardNewProviderShimmer from "componentReusable/Ads/AdsBillBoardNewProvider/AdsBillBoardNewProviderShimmer";
import SMCBannerUtil from "../../../../componentReusable/Ads/SMCAds/SMCBannerUtil";

const SEOTrendingLinksDesktop = dynamic(
  () => import("./common/HomeSeoLinks/HomeSeoTrendingLinksDesktop"),
  { suspense: false }
);
const SEOTrendingLinksMobile = dynamic(
  () => import("./common/HomeSeoLinks/HomeSeoTrendingLinksMobile"),
  { suspense: false }
);
const AdsBillBoardShimmer = dynamic(
  () =>
    import(
      "../../../../componentReusable/Ads/AdsBillBoard/AdsBillBoardShimmer"
    ),
  { suspense: false }
);
const HomeShobiddakAds = dynamic(() => import("./common/HomeShobiddakAds"), {
  suspense: false,
});

interface IProps {
  isChangeCountryPage: boolean;
  latestPosts: ILatestPostsGroup[];
  seoTrendingBlocks: ISEOTrendingBlock[];
  homeData: IHome;
}

const HomePage: FC<IProps> = (props) => {
  const { seoTrendingBlocks, homeData } = props;
  const { isLoggedInSso, userInfo } = useSsoContext();
  const { isDesktop, isMobile, translations, country } = useTheme();
  const isShowCustomizeAds = useIsCustomizeAds();
  const mpuBanner = SMCBannerUtil.getMPUBanner(country, EnumLoggingScreenNames.HOME);
  const SMCAllowedCountries = process.env.NEXT_PUBLIC_SMC_CAMPAIGN_ALLOWED_COUNTRIES
  const allowedCountries = SMCAllowedCountries;
    return (
    <Fragment>
      {isDesktop && allowedCountries?.split("|").includes(country) && (
        <AdsBillBoardNewProviderShimmer
          adName={`OpenSooq_FoxPush_Sticky_${
            country != "om" ? country.toUpperCase() : "Oman"
          }`}
          className="fixed"
          style={{ minHeight: "250px" }}
        />
      )}
      {isShowCustomizeAds && (
        <Fragment>
          <AdsBillBoardShimmer
            adName={
              isDesktop
                ? "homepage_bottom_sticky_customized_videoplayer_desktop"
                : "mobile_homepage_customized_videoplayer"
            }
            className="fixed homePageStickyDfp"
          />
          <AdsBillBoardShimmer
            adName={
              isDesktop
                ? "homepage_top_customized_leaderboard_desktop"
                : "home_top_customized_leaderboard_mobile"
            }
            className="mt-8 mb-8"
          />
        </Fragment>
      )}
      <HomeBannerOne />
      <main>
        <HomeTaxonomy homeData={homeData} />
        {isDesktop && (
          <HomeAdsHeight>
            <LazyLoadWindowScroll
              render={() => {
                return (
                  <AdsBillBoardShimmer
                    adName="desktop_homepage_mid"
                    className="center mt-16"
                    style={{ height: "90px" }}
                  />
                );
              }}
            />
          </HomeAdsHeight>
        )}
        {isMobile && (
          <HomeAdsHeight {...classNames("mt-8 mb-8", isMobile && "mobileCardBorder")}>
            {mpuBanner ?  mpuBanner.body
            :
            <LazyLoadWindowScroll
              render={() => {
                return (
                  <AdsBillBoardShimmer
                    adName="mobile_homepage_mid"
                    className="mobileCardBorder center"
                    style={{ height: "266px", padding: "0" }}
                  />
                );
              }}
            />}
          </HomeAdsHeight>
        )}
        {getCustomThemeValue("adTheme") == "shobiddak" && isDesktop && (
          <HomeShobiddakAds />
        )}
        {isDesktop ? (
          <Fragment>
            <HomeBannerTwo />
            <HomeWidgets homeData={homeData} />
          </Fragment>
        ) : (
          <Fragment>
            <HomeWidgets homeData={homeData} />
            {!isShobiddak() && (
              <AdsContainer className="p-16 mb-16 mobileCardBorder">
                <LazyLoadWindowScroll
                  render={() => {
                    return (
                      <AdsBillBoardShimmer adName="homepageBottom-mobile" />
                    );
                  }}
                />
                {isShowCustomizeAds && (
                  <AdsBillBoardShimmer
                    adName="home_bottom_customized_leaderboard_sticky_mobile"
                    className="stickyAdsBottom fixed"
                  />
                )}
              </AdsContainer>
            )}
            <HomeBannerTwo />
          </Fragment>
        )}
      </main>
      <div
        {...classNames(
          isDesktop && "flex gap-20 mb-32 mt-32",
          isMobile && "p-8"
        )}
      >
        <WidgetAddListing isSameLine member_id={userInfo?.id} />
        <WidgetGetMoreListing isSameLine member_id={userInfo?.id} />
      </div>
      {seoTrendingBlocks &&
        isLoggedInSso == false &&
        (isDesktop ? (
          <SEOTrendingLinksDesktop seoTrendingBlocks={seoTrendingBlocks} />
        ) : (
          <aside>
            <SEOTrendingLinksMobile seoTrendingBlocks={seoTrendingBlocks} />
          </aside>
        ))}
      {isMobile && (
        <AddPostProvider
          iframeUrl={getIntegrationLink(EnumIntegrationEvent.ADD_POST)}
          widgetName={EnumWidgets.HEADER}
          render={({ onClickCb }) => (
            <AddPostCont className="addPostCont fixed flex justifyContent width-100" hasSMCAd={SMCAllowedCountries}>
              <button
                className="addPostLink orangeBtn flex alignItems width-fit boxShadow"
                onClick={onClickCb}
              >
                <IconAddPost
                  className="inline vMiddle me-8"
                  fill="#fff"
                  width="22"
                  height="22"
                />
                {translations.addPostM}
              </button>
            </AddPostCont>
          )}
        />
      )}
    </Fragment>
  );
};
export default HomePage;
